// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogVariant__Queries from "./CatalogVariant__Queries.res.js";

let CatalogVariant__Config_TaxRateNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariant__Config.CatalogVariant__Config_TaxRateNotFound");

function makeVariantFilterBy(activeShop, param) {
  return CatalogVariant__Queries.VariantQuery.makeInputObjectInputVariantsByCkuQueryFilter(activeShop !== undefined ? CatalogVariant__Queries.VariantQuery.makeInputObjectInFilter([activeShop.id], undefined) : undefined, undefined, "INCLUDED", undefined);
}

function variantsInformationFromData(data) {
  return data.variantsByCku.edges.map(param => {
    let data = param.node;
    let match = data.formattedStatus;
    let match$1 = data.bulk;
    let match$2 = data.capacityUnit;
    return {
      id: data.id,
      shopId: data.shop.id,
      shopName: data.shop.name,
      updatedAt: data.updatedAt,
      status: match === "INACTIVE" ? "Inactive" : (
          match === "ARCHIVED" ? ({
              TAG: "Archived",
              _0: data.archivedAt
            }) : (
              match === "ACTIVE" ? "Active" : undefined
            )
        ),
      active: Stdlib_Option.getOr(data.active, false),
      name: data.name,
      formattedName: data.formattedName,
      formattedCapacity: Stdlib_Option.map(data.capacityValue, capacityValue => {
        let capacityUnit = data.capacityUnit;
        if (capacityUnit !== undefined) {
          return I18n.decimalFormat(undefined, undefined, 2, undefined, capacityValue) + " " + capacityUnit;
        } else {
          return I18n.decimalFormat(undefined, undefined, 2, undefined, capacityValue);
        }
      }),
      year: Stdlib_Option.map(data.year, year => year.toString()),
      formattedAlcoholVolume: Stdlib_Option.map(data.alcoholVolume, alcoholVolume => I18n.decimalFormat(undefined, undefined, 1, undefined, alcoholVolume) + "°"),
      ean13: data.ean13,
      stockKeepingUnit: data.stockKeepingUnit,
      priceLookUpCode: data.priceLookUpCode,
      internalCode: data.internalCode,
      purchasePrice: data.purchasedPrice,
      taxRate: data.product.tax.value,
      internalNote: Stdlib_Option.getOr(data.internalNote, ""),
      tastingNote: Stdlib_Option.getOr(data.tastingNote, ""),
      capacityUnit: match$1 !== undefined && match$1 && match$2 !== undefined ? match$2 : undefined,
      bulk: Stdlib_Option.getOr(data.bulk, false)
    };
  });
}

function variantsRetailPricesFromData(data) {
  return data.variantsByCku.edges.map(param => {
    let data = param.node;
    return Stdlib_Array.filterMap(data.variantPrices.edges.toSorted((param, param$1) => {
      let currentEnabled = Stdlib_Option.mapOr(param.node.price, false, price => price.enableByDefault);
      let nextEnabled = Stdlib_Option.mapOr(param$1.node.price, false, price => price.enableByDefault);
      if (currentEnabled) {
        if (nextEnabled) {
          return 0;
        } else {
          return -1;
        }
      } else if (nextEnabled) {
        return 1;
      } else {
        return 0;
      }
    }), param => {
      let variantPrice = param.node;
      let taxIncluded = Stdlib_Option.getOr(Stdlib_Option.map(variantPrice.price, price => price.taxIncluded), false);
      let match = variantPrice.price;
      let match$1 = variantPrice.archivedAt;
      if (match === undefined) {
        return;
      }
      if (match.archivedAt !== undefined) {
        return;
      }
      if (match$1 !== undefined) {
        return;
      }
      let match$2 = data.bulk;
      let match$3 = data.capacityUnit;
      return {
        id: variantPrice.id,
        priceId: match.id,
        variantId: data.id,
        shopId: data.shop.id,
        shopName: data.shop.name,
        name: match.name,
        valueExcludingTax: variantPrice.valueExcludingTax,
        valueIncludingTax: variantPrice.valueIncludingTax,
        taxIncluded: taxIncluded,
        taxRate: data.product.tax.value,
        toQuantity: variantPrice.toQuantity,
        fromQuantity: variantPrice.fromQuantity,
        capacityUnit: match$2 !== undefined && match$2 && match$3 !== undefined ? match$3 : undefined
      };
    });
  });
}

function variantsPurchasePriceFromData(data) {
  return data.variantsByCku.edges.map(param => {
    let data = param.node;
    let match = data.bulk;
    let match$1 = data.capacityUnit;
    return {
      id: data.id,
      shopId: data.shop.id,
      shopName: data.shop.name,
      supplierId: Stdlib_Option.mapOr(data.supplier, "", param => param.id),
      supplierName: Stdlib_Option.mapOr(data.supplier, "", param => param.companyName),
      purchasePrice: data.purchasedPrice,
      formattedPurchasedPrice: data.formattedPurchasedPrice,
      capacityUnit: match !== undefined && match && match$1 !== undefined ? match$1 : undefined
    };
  });
}

function variantsStockInformationFromData(data) {
  return data.variantsByCku.edges.map(param => {
    let data = param.node;
    let match = data.bulk;
    let match$1 = data.capacityUnit;
    let match$2 = data.bulk;
    let match$3 = data.capacityPrecision;
    return {
      variantId: data.id,
      shopId: data.shop.id,
      shopName: data.shop.name,
      rawQuantity: Stdlib_Option.getOr(data.stock.rawQuantity, 0),
      formattedQuantity: data.stock.formattedQuantity,
      state: data.stock.state,
      capacityUnit: match !== undefined && match && match$1 !== undefined ? match$1 : undefined,
      capacityPrecision: match$2 !== undefined && match$2 && match$3 !== undefined ? match$3 : undefined,
      maxStockThreshold: Stdlib_Option.mapOr(data.maxStockThreshold, 0, prim => prim),
      minStockThreshold: Stdlib_Option.mapOr(data.minStockThreshold, 0, prim => prim),
      stockOrderTriggerThreshold: Stdlib_Option.mapOr(data.stockOrderTriggerThreshold, 0, prim => prim)
    };
  });
}

function variantProductsInformationFromData(data) {
  return data.variantsByCku.edges.map(param => {
    let data = param.node;
    return {
      id: data.product.id,
      status: undefined,
      name: data.product.name,
      description: data.product.formattedDescription,
      formattedOrigin: data.product.formattedOrigin,
      taxValue: data.product.tax.value,
      categoryId: undefined,
      formattedCategoryName: Stdlib_Option.getOr(data.formattedCategory, I18n.t("Not classified")),
      shopId: data.shop.id,
      shopName: data.shop.name,
      internalNote: ""
    };
  });
}

function makeRetailPricesList(shopsVariant, variantPrices, pricesData) {
  return Stdlib_Array.reduceWithIndex(shopsVariant, [], (acc, variant, index) => Belt_Array.concatMany([
    acc,
    [Belt_Array.concatMany([
        Stdlib_Option.getOr(variantPrices[index], []),
        Stdlib_Array.filterMap(pricesData.prices.edges, param => {
          let price = param.node;
          let match = Stdlib_Option.getOr(variantPrices[index], []).some(variantPrice => variantPrice.priceId === price.id);
          if (match || price.shop.id !== variant.shopId) {
            return;
          } else {
            return {
              id: undefined,
              priceId: price.id,
              variantId: variant.id,
              shopId: variant.shopId,
              shopName: variant.shopName,
              name: price.name,
              valueExcludingTax: 0,
              valueIncludingTax: 0,
              taxIncluded: price.taxIncluded,
              taxRate: variant.taxRate,
              toQuantity: undefined,
              fromQuantity: undefined,
              capacityUnit: variant.capacityUnit
            };
          }
        })
      ])]
  ]));
}

function use(variantResponse, variantShopsResponse, pricesResponse) {
  if (variantResponse.TAG !== "Executed") {
    return "Loading";
  }
  if (variantResponse._0.loading) {
    return "Loading";
  }
  if (variantShopsResponse.TAG !== "Executed") {
    return "Loading";
  }
  if (variantShopsResponse._0.loading) {
    return "Loading";
  }
  if (pricesResponse.TAG !== "Executed") {
    return "Loading";
  }
  if (pricesResponse._0.loading) {
    return "Loading";
  }
  let variantData = variantResponse._0.data;
  if (variantData === undefined) {
    return "Error";
  }
  let variantShopsData = variantShopsResponse._0.data;
  if (variantShopsData === undefined) {
    return "Error";
  }
  let pricesData = pricesResponse._0.data;
  if (pricesData === undefined) {
    return "Error";
  }
  let shopsVariantRetailPrices = makeRetailPricesList(variantsInformationFromData(variantData), variantsRetailPricesFromData(variantData), pricesData);
  let shopsVariantRetailPricesSorted = shopsVariantRetailPrices.map(variantRetailPrices => variantRetailPrices.toSorted((current, next) => {
    let nameOrdering = next.name.localeCompare(current.name);
    if (nameOrdering !== 0) {
      return nameOrdering;
    } else {
      return Primitive_float.compare(Stdlib_Option.getOr(current.fromQuantity, 0), Stdlib_Option.getOr(next.fromQuantity, 0));
    }
  }));
  return {
    TAG: "Data",
    _0: {
      variantShopIds: variantShopsData.variantsByCku.edges.map(param => param.node.shop.id),
      shopsProduct: variantProductsInformationFromData(variantData),
      shopsVariant: variantsInformationFromData(variantData),
      shopsVariantStock: variantsStockInformationFromData(variantData),
      shopsVariantPurchasePrice: variantsPurchasePriceFromData(variantData),
      shopsVariantRetailPrices: shopsVariantRetailPricesSorted
    }
  };
}

let VariantQuery;

let VariantShopsQuery;

let PricesQuery;

let ProductConfig;

export {
  VariantQuery,
  VariantShopsQuery,
  PricesQuery,
  ProductConfig,
  CatalogVariant__Config_TaxRateNotFound,
  makeVariantFilterBy,
  variantsInformationFromData,
  variantsRetailPricesFromData,
  variantsPurchasePriceFromData,
  variantsStockInformationFromData,
  variantProductsInformationFromData,
  makeRetailPricesList,
  use,
}
/* I18n Not a pure module */
